(() => {
  if (customElements.get('moreplus-product-tabs')) return;
  class MoreplusProductTabs extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.querySelector('.mp-select__filters').hidden = false;
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-mp-filter]');
        if (button && this.contains(button)) this.select(button.dataset.mpFilter);
      }, options);
      document.addEventListener('shopify:block:select', event => {
        if (event.detail?.sectionId === this.dataset.sectionId && event.detail.blockId) {
          const button = [...this.querySelectorAll('[data-mp-filter]')].find(b => b.dataset.mpFilter === event.detail.blockId);
          if (button) this.select(button.dataset.mpFilter);
        }
      }, options);
      this.select('all');
    }
    disconnectedCallback() { this.controller?.abort(); }
    select(group) {
      const seen = new Set();
      this.querySelectorAll('[data-mp-product]').forEach(card => {
        const matches = group === 'all' || card.dataset.mpGroup === group;
        card.hidden = !matches || seen.has(card.dataset.mpProduct);
        if (!card.hidden) seen.add(card.dataset.mpProduct);
      });
      this.querySelectorAll('[data-mp-filter]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.mpFilter === group));
      });
      this.querySelector('[data-mp-count]').textContent = `目前顯示 ${seen.size} 件商品`;
      this.querySelector('[data-mp-empty]').hidden = seen.size > 0;
    }
  }
  customElements.define('moreplus-product-tabs', MoreplusProductTabs);
})();
